export class CreateOrUpdateEmployee {
  userId?: number;
  name: string;
  username: string;
  password?: string;
  isActive: boolean;
  phoneNumber: string;
  email: string;
  roleId: string;
}
